module.exports = __webpack_public_path__ + "static/smartly_io-4abbff090a0ca4f983f14cee72e89c07.svg";